<div *ngIf="form">
    <form [formGroup]="form">
        <div class="d-flex align-items-center justify-content-start contact-title">
            <img src="../../../../../assets/icons/new-service-chat.svg" alt="" />
            {{ 'additionalInstructions' | translate }} <small>({{ 'optional' | translate }})</small>
        </div>
        <div class="d-flex flex-column w-100">
            <textarea [formControlName]="formControlName" [placeholder]="placeholder" class="form-textarea"
                maxlength="500"></textarea>
            <p class="d-flex w-100 justify-content-end align-items-center gap-10 m-0">
                {{form.get(formControlName)?.value?.length}}/500
            </p>
        </div>
    </form>
</div>